'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { transformToContentList } from '../../utils/contentoUtils';
import ContentList from '../../ui-components/ContentList/ContentList';
import { createListTrackingOnClick } from '../../utils/statistics/clientStatistics';

const SLIDABLELIST_ID = 'slidable-vtp';

class SimilarVideoContent extends Component {
    render() {
        const { listContent, headerText } = this.props;

        if (!listContent) {
            return null;
        }

        const listItems = transformToContentList(listContent);

        const listTracking = {
            listID: 'upptack mer',
            listType: 'balthazar upptack mer',
        };

        const onItemClick = createListTrackingOnClick(listTracking);

        return (
            <ContentList
                id={SLIDABLELIST_ID}
                items={listItems}
                headerText={headerText}
                onItemClick={onItemClick}
                regTestSpec="video-page-similar-content"
                expandable
            />
        );
    }
}

SimilarVideoContent.propTypes = {
    listContent: PropTypes.object,
    titleArticleId: PropTypes.string,
    isTitlePage: PropTypes.bool,
    headerText: PropTypes.string,
    listTracking: PropTypes.object,
};

export default SimilarVideoContent;
